/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllStepsQueryResponse, DocumentsControllerFindAllStepsPathParams, DocumentsControllerFindAllSteps401, DocumentsControllerFindAllSteps403 } from "../../models/documentsController/DocumentsControllerFindAllSteps";

function getDocumentsControllerFindAllStepsUrl(id: DocumentsControllerFindAllStepsPathParams["id"], processingId: DocumentsControllerFindAllStepsPathParams["processingId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing/${processingId}/steps` as const }  
  return res
}

/**
 * @summary Get all steps for a processing job
 * {@link /api/v1/documents/:id/processing/:processingId/steps}
 */
export async function documentsControllerFindAllSteps(id: DocumentsControllerFindAllStepsPathParams["id"], processingId: DocumentsControllerFindAllStepsPathParams["processingId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindAllStepsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllSteps401 | DocumentsControllerFindAllSteps403>, unknown>({ method : "GET", url : getDocumentsControllerFindAllStepsUrl(id, processingId).url.toString(), ... requestConfig })  
  return res.data
}